<div class="cg-flex-vertical-center">
  <div class="flag-block">
    <cigna-flag
      data-test="flagicon"
      [disabled]="!isEditable"
      size="medium"
      [flagged]="flaggedKeys.includes(precert.precertNumber)"
      (change)="flagClick($event, precert)"
    ></cigna-flag>
  </div>
  <div class="name-block divider-right">
    <div class="cg-margin-bottom-sm">
      <a
        class="cg-font-size-m"
        *ngIf="!isRestrictedImpersonator"
        data-test="patientplandetail"
        [routerLink]="[
          '/patient/precertification/detail/',
          precert.precertNumber
        ]"
        [queryParams]="{
          asof: precert.payload.member.asOfDate,
          compositeKey: precert.payload.compositeKey,
          patientPlan: precert.payload.member.patientPlan,
          precertSource: precert.payload.precertificaton.precertSource
        }"
      >
        <strong data-test="patientName">
          {{ precert.payload.member.patientFirstName }}
          {{ precert.payload.member.patientLastName }}</strong
        >
      </a>
      <strong *ngIf="isRestrictedImpersonator"
        >{{ precert.payload.member.patientFirstName }}
        {{ precert.payload.member.patientLastName }}</strong
      >
    </div>
    <div class="secondary-text cg-font-size-xs">
      {{ 'dashboard.dashboardComponent.patientId' | translate }}
    </div>
    <div data-test="patientId">
      {{
        !isRestrictedImpersonator
          ? precert.payload.member.memberId || '--'
          : '--'
      }}
    </div>
  </div>

  <div class="cg-flex-column">
    <div *ngIf="isFlagView" class="date-flagged-block cg-flex">
      <div class="cg-font-size-xs">
        {{ 'dashboard.dateFlagged' | translate }}
        {{ precert?.createdDt | date: 'MM/d/yyyy' }}
      </div>
    </div>
    <div *ngIf="!isFlagView" class="date-flagged-block cg-flex">
      <div class="cg-font-size-xs">
        {{ 'dashboard.eligibilityAsOfDate' | translate }}
        {{ precert.payload.member.asOfDate | date: 'MM/d/yyyy' }}
      </div>
    </div>
    <div class="detail-block" style="margin-top: -15px">
      <div class="cg-margin-right-sm">
        <div class="cg-margin-bottom-sm">
          <cigna-precert-status
            [status]="precert.payload.precertificaton.status"
            size="small"
          >
          </cigna-precert-status>
        </div>
        <div class="secondary-text cg-font-size-xs">
          {{ 'dashboard.dashboardComponent.precertNumber' | translate }}
        </div>
        <div data-test="precertNumber">
          <a
            *ngIf="!isRestrictedImpersonator"
            [routerLink]="[
              '/patient/precertification/detail/',
              precert.precertNumber
            ]"
            [queryParams]="{
              asof: precert.payload.member.asOfDate,
              compositeKey: precert.payload.compositeKey,
              patientPlan: precert.payload.member.patientPlan,
              precertSource: precert.payload.precertificaton.precertSource
            }"
          >
            #{{ precert.precertNumber }}
          </a>
          <span *ngIf="isRestrictedImpersonator">--</span>
        </div>
      </div>

      <div class="cg-margin-right-sm" style="width: 175px">
        <div class="cg-margin-bottom-sm">
          <div class="secondary-text cg-font-size-xs">
            {{ 'dashboard.dashboardComponent.requestingProvider' | translate }}
          </div>
          <div data-test="requestingProvider">
            {{
              precert.payload.providerDetails.requestingProvider?.name || '--'
            }}
          </div>
        </div>
        <div class="secondary-text cg-font-size-xs">
          {{ 'dashboard.dashboardComponent.servicingProvider' | translate }}
        </div>
        <div data-test="servicingProvider">
          {{ precert.payload.providerDetails.servicingProvider?.name || '--' }}
        </div>
      </div>

      <div>
        <div class="secondary-text cg-font-size-xs">
          {{ 'dashboard.dashboardComponent.dos' | translate }}:
        </div>
        <div data-test="datesOfService">
          {{ precert.payload.precertificaton.startDate | date: 'MM/dd/yyyy' }} -
          {{ precert.payload.precertificaton.endDate | date: 'MM/dd/yyyy' }}
        </div>
      </div>
    </div>
  </div>
</div>
